const StringUtil = {
  uuid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },

  tipoAtendimento(tipo) {
    var tipoArray = ["PRIMEIRA CONSULTA", "RETORNO", "CANCELADO"];
    return tipoArray[parseInt(tipo) - 1];
  },

  // TODO: Implementar validação mais criteriosa se necessário
  validarEmail(email) {
    return email.includes("@");
  },

  // TODO: Implementar validação real se necessário
  validarCpf(cpf) {
    cpf = this.unmask(cpf);
    return cpf.length >= 11;
  },

  mask(texto, mask) {
    var textoMasked = "";
    var posicao = 0;
    for (var i = 0; i < mask.length; i++) {
      var chr = mask.charAt(i);

      // Substitui os caracteres da máscara
      if (posicao === texto.length) {
        return textoMasked;
      } else if (chr === "9") {
        textoMasked += texto.charAt(posicao);
        posicao++;
      } else textoMasked += chr;
    }
    return textoMasked;
  },

  unmask(texto) {
    return texto.replace(/[^a-zA-Z0-9]/g, "");
  },

  nomeVinculo(codigo) {
    switch (codigo) {
      case 0:
        return "Indefinido";
      case 1:
        return "CLT";
      case 2:
        return "Autônomo";
      case 3:
        return "Sócio/Proprietário";
      case 4:
        return "Estágiario";
      case 5:
        return "Prestador de Serviço";
      default:
        return "";
    }
  },

  nomePerfil(codigo) {
    switch (codigo) {
      case 0:
        return "X-Brain";
      case 1:
        return "Administrador";
      case 2:
        return "Operador";
      default:
        return "";
    }
  },

  tipoInativacao(codigo) {
    switch (codigo) {
      case 1:
        return "GESTANTE";
      case 2:
        return "ESTIMULAÇÃO PRECOCE";
      case 3:
        return "CRIANÇA";
      case 4:
        return "HIPERTENSÃO";
      case 5:
        return "DIABETE";
      case 6:
        return "IDOSO";
      case 7:
        return "GINECOLOGIA";
      case 8:
        return "SAÚDE MENTAL";
      default:
        return "NENHUMA";
    }
  },

  estadoCivil(codigo) {
    switch (codigo) {
      case 1:
        return "SOLTEIRO (A)";
      case 2:
        return "CASADO (A)";
      case 3:
        return "SEPARADO (A)";
      case 4:
        return "DIVORCIADO (A)";
      case 5:
        return "VIÚVO (A)";
      default:
        return "NÃO INFORMADO";
    }
  },

  classificacao(codigo) {
    switch (codigo) {
      case 1:
        return "INATIVO (SEM MOTIVO)";
      case 2:
        return "ALTA";
      case 3:
        return "DESLIGAMENTO";
      case 4:
        return "ENCAMINHAMENTO";
      case 5:
        return "OUTROS";
      default:
        return "ATIVO";
    }
  },

  classificacaoCategoria(codigo) {
    switch (codigo) {
      case "RECEITAS":
        return "RECEITAS";
      case "IMPOSTOS":
        return "IMPOSTOS";
      case "DESPESAS_FIXAS":
        return "DESPESAS FIXAS";
      case "DESPESAS_VARIAVEIS":
        return "DESPESAS VARIÁVEIS";
      case "GASTOS_COM_PESSOAL":
        return "GASTOS COM PESSOAL";
      default:
        return "TODAS";
    }
  },

  classeCategoria(codigo) {
    switch (codigo) {
      case "RECEITAS":
        return "badge-receita";
      default:
        return "badge-despesa";
    }
  },

  serialize(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  },
};

export default StringUtil;
